import { Component, OnInit, ViewChild } from '@angular/core';
//import { ModalIncidentComponent } from '../modales/modal.incident.component';
import { Observable } from 'rxjs/Observable';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from 'app/shared/services/storage.service';
import { SecurityService } from 'app/shared/services/security.service';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { AppConfig } from 'app/app.config';
import { IDtoEvent } from 'app/shared/models/incident/dto-event.model';
import { IncidentService } from '../incident.service';
import { EmployeeService } from '../employee.service';
import { IDtoJobCandidateBasic } from 'app/shared/models/employee/dto-jobcandidate-basic.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalIncidentComponent } from 'app/views/modales/incident/modal.incident.component';
import { IDtoTicket } from 'app/shared/models/incident/dto-ticket.model';
@Component({
  selector: 'incident',
  templateUrl: './incident.template.html',
  styleUrls: ['./incident.style.scss'],
})

export class IncidentComponent implements OnInit {
  private showRoles: any;
  private formIncident: FormGroup;
  private config = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
  };
  private itemsPageList: number[] = [5, 10, 15, 20, 30, 50];
  private page: number = 2;
  private itemsPage: number = 20;
  private errorReceived: boolean;
  private listEvents = [];
  private listEventsPage = [];
  private listTickets = [] as IDtoTicket[];
  private listEventsFilter: any[] = [];
  private listEmployees = [] as IDtoCatalog[];
  private event: IDtoEvent;
  private router: Router;
  private desde: Date;
  private hasta: Date;
  private typeFilter = 'tickets';
  private isEvent: boolean;
  private perfilSeleccionado = 'owner';
  /* Variables para count*/
  private countPending: number;
  private countSolved: number;
  private countOpen: number;
  private countInProcess: number;
  profile: string;
  private modalRef?: BsModalRef;
  @ViewChild('sentCloseIncident', { static: false }) private sentCloseIncident: SwalComponent;
  employee: IDtoJobCandidateBasic;
  @ViewChild('tab2', { static: false }) private tab2;
  constructor(private incidentService: IncidentService
    , private formBuilder: FormBuilder
    , router: Router
    , private storageService: StorageService
    , private configurationService: ConfigurationService
    , private securityService: SecurityService
    , public configGeneral: AppConfig
    , private employeeService: EmployeeService
    , private spinner: NgxSpinnerService
    , private modalService: BsModalService
    , private route: ActivatedRoute) {
    this.showRoles = this.securityService.getUserRolesStorage();
    this.router = router;
    this.profile = this.securityService.getProfileStorage('Incident');
  }

  public ngOnInit() {
    if (this.configurationService.isReady) {
      this.getEmployee();
    } else {
      this.configurationService.settingsLoaded$.subscribe(x => {
        this.getEmployee();
      });
    }
    this.desde = new Date(new Date().getTime() - (1000 * 60 * 60 * 24) * 5);
    this.hasta = new Date(new Date().getTime() + (1000 * 60 * 60 * 24));
    this.isEvent = false;
    this.getDataFilters();
    this.formIncident = this.formBuilder.group({
      selItemPage: new FormControl(null),
      paginaIncident: new FormControl(null),
      dtpStart: [null],
      dtpEnd: [null],
    });
    this.formIncident.controls['selItemPage'].setValue(this.itemsPage, { onlySelf: true });
  }

  private mostrarElementos(item: any, data: any[]): void {
    this.itemsPage = item;
    const startItem = (1 - 1) * this.itemsPage;
    const endItem = 1 * this.itemsPage;
    this.listEventsPage = data.slice(startItem, endItem);
    this.page = 1;
  }

  private getEvents(perfilSeleccionado: string) {
    this.countInProcess = 0;
    this.countOpen = 0;
    this.countPending = 0;
    this.countSolved = 0;
    this.incidentService.getEventsByDate(
      `${(this.desde.getMonth() + 1)}-${this.desde.getDate()}-${this.desde.getFullYear()}`
      , `${(this.hasta.getMonth() + 1)}-${this.hasta.getDate()}-${this.hasta.getFullYear()}`
      , this.showRoles.employeeId
      , perfilSeleccionado)
      .catch((err) => this.handleError(err))
      .subscribe((data) => {
        this.listEvents = data;
        this.mostrarElementos(this.itemsPage, data);
        if (this.listEvents.length > 0) {
          this.countsStatesIncidents();
          this.filterTicketsByStatus(1);
        }
      });
  }
  private getEmployee(): void {
    this.employeeService.getEmployee(this.showRoles.employeeId).subscribe((res) => {
      this.employee = res.data as IDtoJobCandidateBasic;
    },
      (errMessage) => {
        this.spinner.hide();
        this.configGeneral.newToast('Error', errMessage.message, 'error');
      });
  }
  private getTickets(perfilSeleccionado: string) {
    this.countInProcess = 0;
    this.countOpen = 0;
    this.countPending = 0;
    this.countSolved = 0;
    this.incidentService.getTicketsByDate(
      `${(this.desde.getMonth() + 1)}-${this.desde.getDate()}-${this.desde.getFullYear()}`
      , `${(this.hasta.getMonth() + 1)}-${this.hasta.getDate()}-${this.hasta.getFullYear()}`
      , this.showRoles.employeeId
      , perfilSeleccionado)
      .catch((err) => this.handleError(err))
      .subscribe((data) => {
        this.listEvents = data;
        this.mostrarElementos(this.itemsPage, data);
        if (this.listEvents.length > 0) {
          this.countsStatesIncidents();
          this.filterTicketsByStatus(1);
        }
      });
  }

  private getDataBy(perfilSeleccionado: string) {
    this.perfilSeleccionado = perfilSeleccionado;
    switch (this.typeFilter) {
      case 'events':
        this.getEvents(perfilSeleccionado);
        break;
      case 'tickets':
        this.getTickets(perfilSeleccionado);
        break;
    }
  }

  private filterTicketsByStatus(status: number): void {
    this.listEventsPage = this.listEvents.filter(x => x.status === status);
  }

  private getTicket(item: IDtoEvent) {

    this.incidentService.getTickets(item.eventId)
      .catch((err) => this.handleError(err))
      .subscribe((data) => {
        this.listTickets = data;
      });
  }

  private getDataFilters() {
    if(this.tab2) {
      this.tab2.nativeElement.checked = true;
    }
    switch (this.typeFilter) {
      case 'events':
        this.isEvent = true;
        this.getEvents('owner');
        break;
      case 'tickets':
        this.isEvent = false;
        this.getTickets('owner');
        break;
    }
  }

  private onSelectionChange(entry) {
    this.typeFilter = entry;
    switch (this.typeFilter) {
      case 'events':
        this.isEvent = true;
        break;
      case 'tickets':
        this.isEvent = false;
        break;
    }
  }

  //
  private countsStatesIncidents() {
    this.countOpen = this.listEvents.filter(x => x.status === 1).length;
    this.countInProcess = this.listEvents.filter(x => x.status === 2).length;
    this.countPending = this.listEvents.filter(x => x.status === 3).length;
    this.countSolved = this.listEvents.filter(x => x.status === 4).length;
  }
  //
  private pageChanged(event: PageChangedEvent): void {
    const startItem = (event.page - 1) * event.itemsPerPage;
    const endItem = event.page * event.itemsPerPage;
    this.listEventsPage = this.listEventsFilter.slice(startItem, endItem);
  }

  private filterEvents = (events) => {
    this.listEventsFilter = events;
    this.mostrarElementos(this.itemsPage, events);
  }

  private handleError(error: any) {
    this.errorReceived = true;
    return Observable.throw(error);
  }
  // TODO: //Cool
  private detailIncidentGo(item) {
    if (item.ticketId == undefined) {
      this.router.navigate(['/incident/detail',
        { eventId: item.eventId }], { relativeTo: this.route });
    } else {
      this.router.navigate(['/incident/detail',
        { ticketId: item.ticketId }], { relativeTo: this.route });
    }
  }

  private getCatalogsModal(item: any, accion: string, id: number) {
    this.openModalIncident(item, accion, id);
    const t = this.incidentService.listCatalogsChallenge$.subscribe((res) => {
      t.unsubscribe();
    });
  }
  //
  private questCloseEvent(item: IDtoEvent) {
    switch (item.type) {
      case 'Incident':
        this.sentCloseIncident.title = 'Se va a cerrar el ticket seleccionado.';
        break;
      case 'Request':
        this.sentCloseIncident.title = 'Se va a cerrar el evento seleccionado. ' +
          'Todos los tickets asociados al evento se cerrarán';
        break;
    }
    this.event = item;
    this.sentCloseIncident.show();
  }

  private closeEvent() {
    this.incidentService.closeEvent(this.event)
      .catch((err) => this.handleError(err))
      .subscribe((data) => {
        if (data.isCorrect) {
          this.configGeneral.newToast('¡Exito!', 'Evento cerrado', 'success');
          this.event.status = 4;
        } else {
          this.configGeneral.newToast('¡Error!', 'Error al procesar los datos', 'error');
        }
      });
  }

  private openModalIncident(item: any, acc: string, id: number) {
    const initialState = {
      title: 'Información del ticket',
      accion: acc,
      eventId: id,
      employee: this.employee
    };

    this.modalRef = this.modalService.show(ModalIncidentComponent
      , Object.assign({ initialState }
        , { class: 'gray modal-lg' }, this.config));
    this.modalRef.content.closeBtnName = 'Close';
    this.modalRef.content.onClose.subscribe((result) => {
      if (result != null) {
        switch (acc) {
          case ('nuevo'):
            if (this.perfilSeleccionado === 'owner') {
              this.listEventsFilter.push(result);
              this.mostrarElementos(this.itemsPage, this.listEventsFilter);
            }
            break;
          case ('editar'):
          case ('reemplazar'):
            break;
        }
      }
    });
  }
}
